import * as React from 'react';
import { useSelector } from 'react-redux';

import { SecondaryContactButtons } from '../../components/SecondaryContactButtons';
import { getBuilderChatEnabled } from '../../selectors/builderChat';
import { selectMessageButtonAvailable } from '../../selectors/messageButton';
import { getIsFlatViewOrderEnabled } from '../../selectors/newbuilding';
import { getAgentForCallback } from '../../selectors/newbuilding/agent';
import { CallMeBackContainer } from '../CallMeBack';
import { FlatViewOrderButtonContainer } from '../FlatViewOrderButton';
import { MessageButtonContainer } from '../MessageButton';

export const SecondaryContactButtonsContainer = () => {
  const isFlatViewEnabled = useSelector(getIsFlatViewOrderEnabled);
  const agentForCallback = useSelector(getAgentForCallback);
  const isMessageButtonAvailable = useSelector(selectMessageButtonAvailable);
  const isBuilderChatEnabled = useSelector(getBuilderChatEnabled);

  if (!agentForCallback && !isFlatViewEnabled && !isMessageButtonAvailable) {
    return null;
  }

  let button: React.ReactNode = null;

  if (isMessageButtonAvailable) {
    button = <MessageButtonContainer withOnboarding />;
  } else if (agentForCallback) {
    button = <CallMeBackContainer placeType="floating_block" />;
  }

  return (
    <SecondaryContactButtons
      leftButton={isFlatViewEnabled ? <FlatViewOrderButtonContainer /> : null}
      rightButton={button}
      // TODO: В CD-226263 при выпиле онбординга обсудить сделать кнопки в 2 колонки и убрать этот проп.
      stretch={isBuilderChatEnabled}
    />
  );
};
